"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var server_1 = require("react-dom/server");
function default_1(base, legend, optionModifiers) {
    var showLegend = base.showLegend, chartType = base.chartType;
    var defaultOptions = __assign({ enabled: showLegend, useHTML: true, symbolRadius: 0, symbolHeight: 12, symbolWidth: 12, itemStyle: {
            textOverflow: 'ellipsis',
            fontWeight: 'inherit',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            color: 'inherit'
        } }, optionModifiers);
    var options = __assign({}, defaultOptions);
    if (chartType === 'gantt') {
        options.enabled = false;
    }
    if (legend) {
        var _a = legend.props, children = _a.children, position = _a.position, titleText = _a.titleText, titleStyle = _a.titleStyle, labelPrefix = _a.labelPrefix, labelSuffix = _a.labelSuffix, overrides_1 = __rest(_a, ["children", "position", "titleText", "titleStyle", "labelPrefix", "labelSuffix"]);
        var spaces = { small: 10, medium: 20, large: 40 };
        var _b = overrides_1.itemSpacing.split(' '), size = _b[0], vSize = _b[1];
        overrides_1.itemDistance = spaces[size];
        overrides_1.itemMarginBottom = spaces[vSize || size];
        if (position) {
            var _c = position.split(' '), align = _c[0], verticalAlign = _c[1];
            overrides_1.align = align;
            overrides_1.verticalAlign = verticalAlign;
        }
        if (titleText) {
            overrides_1.title.text = titleText;
        }
        if (titleStyle) {
            overrides_1.title.style = titleStyle;
        }
        if (labelPrefix) {
            overrides_1.labelFormat = labelPrefix + " " + overrides_1.labelFormat;
        }
        if (labelSuffix) {
            overrides_1.labelFormat = overrides_1.labelFormat + " " + labelSuffix;
        }
        if (!overrides_1.itemClickEnabled) {
            overrides_1.itemStyle = __assign(__assign({}, overrides_1.itemStyle), { cursor: 'default' });
        }
        if (overrides_1.renderLabel) {
            overrides_1.labelFormat = undefined;
            overrides_1.labelFormatter = function () {
                var label = React.createElement("div", { className: "legend-custom-label" }, overrides_1.renderLabel(this));
                var stringifiedLabel = server_1.renderToString(label);
                return stringifiedLabel;
            };
        }
        options = __assign(__assign({}, options), overrides_1);
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=legendOptions.js.map